import Accordion from './AccordionParts/accordion';
import AccordionContent from './AccordionParts/accordionContent';
import AccordionTitle from './AccordionParts/accordionTitle';

export { AccordionContent, AccordionTitle };
export default Accordion;
